import React, { useEffect } from "react";
import { DatePicker, LocalizationProvider, MobileTimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import TextField from "./FormElements/TextField";

const DateAndTime = ({ startDate, setStartDate, startTime, setStartTime }) => {
  useEffect(() => {
    if (!startDate || !startTime) {
      const now = new Date();
      setStartDate(now);
      setStartTime(new Date(now.setHours(now.getHours(), now.getMinutes(), 0, 0)));
    }
  }, [startDate, startTime, setStartDate, setStartTime]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        value={startDate}
        format="dd/MM/yyyy"
        onChange={(newValue) => setStartDate(newValue)}
        slotProps={{ textField: { size: "small" } }}
      />
      <MobileTimePicker
        label="Select Time"
        value={startTime}
        onChange={(newValue) => setStartTime(newValue)}
        slotProps={{ textField: { size: "small" } }}
      />
    </LocalizationProvider>
  );
};

export default DateAndTime;
